export default "__VITE_ASSET__5704a827__"